export default __webpack_public_path__ + "static/media/advertiser.9937b84d.svg";